import { INotificationProps } from '@hl/ui-components';
import React, { Suspense, useContext, useState } from 'react';
import './global-toast.scss';

const GlobalToast = React.lazy(() => import('./GlobalToast'));

export type GlobalToastConfig = Partial<INotificationProps>;

export type GlobalToastConfigSetter = (config: GlobalToastConfig) => void;

export const GlobalToastContext = React.createContext<GlobalToastConfigSetter>(() => {});
GlobalToastContext.displayName = 'GlobalToastContext';

export const useGlobalToast = () => {
  return useContext(GlobalToastContext);
};

const GlobalToastProvider: React.FCC = ({ children }) => {
  const [config, setToastMessage] = useState<GlobalToastConfig | null>(null);
  return (
    <GlobalToastContext.Provider value={setToastMessage}>
      <>
        <Suspense fallback={<></>}>
          {config && <GlobalToast config={config} onHide={() => setToastMessage(null)} />}
        </Suspense>
        {children}
      </>
    </GlobalToastContext.Provider>
  );
};

export default GlobalToastProvider;

export const withGlobalToastProvider = <T,>(Component: React.FCC<T>) => {
  const ComponentWithToast: React.FCC<T> = (props) => {
    return (
      <GlobalToastProvider>
        <Component {...props} />
      </GlobalToastProvider>
    );
  };
  return ComponentWithToast;
};
